import type { FixedFilterOp } from 'src/components/star-grid/datasets/datasetTypes';

/** Operators that take a comma-separated list of values. */
export const LIST_OPS: ReadonlySet<FixedFilterOp> = new Set(['in', 'not_in']);

/** How many values an operator needs: `between` a low and a high, a list one or more, the rest one. */
export function valueCount(op: FixedFilterOp): number | 'many' {
  if (op === 'between') return 2;
  return LIST_OPS.has(op) ? 'many' : 1;
}

/** The values an operator keeps when switched to. */
export function valuesFor(op: FixedFilterOp, values: readonly string[]): string[] {
  const count = valueCount(op);
  if (count === 'many') return [...values];
  return Array.from({ length: count }, (_, index) => values[index] ?? '');
}
